import React from "react"
import { Link } from "gatsby"
import Layout from "../components/Layout"

const siteUrl = "https://gregwoodwardphoto.com"
const CAREER_START_YEAR = 2011
const yearsActive = new Date().getFullYear() - CAREER_START_YEAR

const awards = [
  ["2018", "Portrait of Britain, Winner"],
  ["2017", "IPF Awards, Shortlist & Exhibition"],
  ["2016", "AOP Open Award, Shortlist & Exhibition"],
]

const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "ProfilePage",
      mainEntity: {
        "@type": "Person",
        name: "Greg Woodward",
        jobTitle: "Commercial Photographer and Director",
        url: siteUrl,
        sameAs: [
          "https://www.instagram.com/gregwoodwardphoto/",
        ],
        address: {
          "@type": "PostalAddress",
          addressLocality: "London",
          addressCountry: "GB",
        },
        knowsAbout: [
          "Commercial photography",
          "Lifestyle photography",
          "Travel photography",
          "Sports photography",
          "Documentary photography",
          "Brand film production",
          "Video direction",
          "Campaign photography",
          "Corporate photography",
        ],
        award: [
          "Portrait of Britain, Winner (2018)",
          "IPF Awards, Shortlist & Exhibition (2017)",
          "AOP Open Award, Shortlist & Exhibition (2016)",
        ],
        hasCredential: awards.map(([year, title]) => ({
          "@type": "EducationalOccupationalCredential",
          name: title,
          dateCreated: year,
        })),
        worksFor: [
          { "@type": "Organization", name: "TUI" },
          { "@type": "Organization", name: "Nike" },
          { "@type": "Organization", name: "HSBC" },
          { "@type": "Organization", name: "Team GB" },
          { "@type": "Organization", name: "British Gas" },
          { "@type": "Organization", name: "Alzheimer's Research UK" },
        ],
      },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "About", item: `${siteUrl}/about/` },
      ],
    },
  ],
}

export default function About() {
  return (
    <Layout
      seo={{
        title: "About Greg Woodward | Commercial Photographer & Director",
        description:
          "Greg Woodward is a commercial photographer and director based in London, working across lifestyle, sport, documentary and video commissions worldwide.",
        pathname: "/about/",
        schema,
      }}
    >
      <main className="service-page">
        <div className="page-intro">
          <div>
            <span className="service-label">About</span>
            <h1>Hi, I'm Greg.</h1>
          </div>
          <p>
            Photographer and director based in London, working across
            lifestyle, sport, documentary and video commissions for brands
            and organisations worldwide.
          </p>
        </div>

        <div className="case-study__prose">
          <p className="about-body">
            Since {CAREER_START_YEAR}, I've undertaken freelance commissions
            across four continents and over 40 countries, working both
            solo and with crew, including projects in Antigua, India, Ibiza,
            Finland, Egypt, Russia, Vietnam, Mexico, Barbados, China,
            Thailand and the USA, to name a few. That's {yearsActive} years
            shooting a mixture of lifestyle and sports stills and everything
            in between, as well as directing and shooting video.
          </p>
          <p className="about-body">
            My clients include, but are not limited to, TUI UK, Nike, Puma,
            The AA, British Gas, Tesco, Team GB, Lego, Deliveroo, HSBC,
            Vice, Jeep, Grosvenor Hotels, Meliá Hotels, Hawes &amp; Curtis,
            TM Lewin and Ark.
          </p>
          <p className="about-body">
            I love this job and find nothing more satisfying than seeing an
            excellent concept realised. I'm always seeking commissions and
            looking to expand my portfolio, so if you have a project you'd
            like to work on together, don't hesitate to ask.
          </p>
          <p className="about-body about-signoff">Cheers, Greg</p>
        </div>

        <div className="service-questions">
          <span className="service-label">Awards &amp; competitions</span>
          {awards.map(([year, title]) => (
            <section key={year}>
              <h2>{year}</h2>
              <p>{title}</p>
            </section>
          ))}
        </div>

        <div className="service-cta">
          <span>Have a project in mind?</span>
          <Link to="/contact/">
            Start a conversation <span aria-hidden="true">↗</span>
          </Link>
        </div>
      </main>
    </Layout>
  )
}
